/**
 * Documentation MARIDA API
 * ## Common Request Headers - Authorization (string `Bearer {AccessToken}`, if signed-in) - After the client has successfully obtained `AccessToken` via Login, it\'s sent in every request as a bearer token.
 *
 * The version of the OpenAPI document: 1
 * Contact: novak@techcrowd.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateCalculationRequest { 
    /**
     * test
     */
    validUntil?: string;
    /**
     * test
     */
    height: number;
    /**
     * test
     */
    width: number;
    /**
     * test
     */
    count: number;
    serviceIds?: Array<number>;
    colorIds?: Array<number>;
    /**
     * test
     */
    realizationPrice?: number;
    /**
     * test
     */
    calculatedPrice?: number;
    /**
     * test
     */
    realizationDescription?: string;
    /**
     * test
     */
    realization: boolean;
    /**
     * test
     */
    customerId?: number;
    /**
     * test
     */
    typeId: number;
}

